import type { FunctionComponent } from "react";

import CardValue from "~/components/Card/components/CardValue.tsx";
import Headline from "~/components/Headline/Headline";
import type { EInvoiceLineItem } from "~/modules/billing/api/eInvoice/eInvoiceTypes.ts";

import { formatEInvoiceCents, formatEInvoicePercent } from "../eInvoiceFormat.ts";

type Props = { lineItem: EInvoiceLineItem };

const EInvoiceLineItemSection: FunctionComponent<Props> = ({ lineItem }) => (
	<div className="col-span-2 grid grid-cols-2 gap-x-8 gap-y-4">
		<Headline type="h5"
				  className="col-span-2">Rechnungsposition</Headline>
		<CardValue label="Beschreibung">{lineItem.description ?? "—"}</CardValue>
		<CardValue label="Menge">{lineItem.quantity} (Mengeneinheit: {lineItem.unitCode})</CardValue>
		<CardValue label="Einzelpreis">{formatEInvoiceCents(lineItem.netPrice)}</CardValue>
		<CardValue label="Positionssumme">{formatEInvoiceCents(lineItem.lineTotalAmount)}</CardValue>
		<CardValue label="USt-Satz">{formatEInvoicePercent(lineItem.vatRate)}</CardValue>
		<CardValue label="USt-Kategorie">{lineItem.vatCategoryCode}</CardValue>
	</div>
);

export default EInvoiceLineItemSection;
